import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map, of } from "rxjs";
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {

  constructor(private http: HttpClient,) { }

  refreshToken() {
    const token = localStorage.getItem("refresh-token");
    if (!token) {
      return of(undefined);
    }

    return this.http.post(`${environment.apiUrl}/account/refreshToken`, { refreshToken: token }).pipe(
      map((res: any) => {
        window.localStorage.setItem('token', res.token.accessToken)
        window.localStorage.setItem('refresh-token', res.token.refreshToken)
        window.localStorage.setItem('currentUser', JSON.stringify(res.user))
        return res;
      }),
    );
  }
}
